import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, School, Book, Edit, Save, X, Key, CreditCard, LogOut, ChevronRight, Eye, EyeOff, CheckCircle, Camera } from 'lucide-react';
import { PasswordChangeModal } from './modals/PasswordChangeModal';
import { EmailUpdateModal } from './modals/EmailUpdateModal';
import { LogoutConfirmModal } from './modals/LogoutConfirmModal';
import { useUser } from './UserContext';
export function OgretmenProfil() {
  const navigate = useNavigate();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const {
    profileImage,
    setProfileImage,
    userData,
    updateUserData
  } = useUser();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: userData.name,
    school: userData.school
  });
  // Modal states
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  // Success notification state
  const [showSaveSuccess, setShowSaveSuccess] = useState(false);
  const handleSave = () => {
    updateUserData({
      name: formData.name,
      school: formData.school
    });
    setIsEditing(false);
    setShowSaveSuccess(true);
    setTimeout(() => {
      setShowSaveSuccess(false);
    }, 3000);
    // Here you would typically send this data to your API
    console.log('Profil güncellendi:', formData);
  };
  const handleProfileImageClick = () => {
    fileInputRef.current?.click();
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // In a real app, you would upload this file to your server/cloud storage
    // For now, we'll just create a local URL
    const imageUrl = URL.createObjectURL(file);
    setProfileImage(imageUrl);
  };
  return <div className="space-y-8" data-id="element-1638">
      <h1 className="text-2xl font-bold" data-id="element-1639">Profilim</h1>
      {/* Success Notification */}
      {showSaveSuccess && <div className="fixed top-6 right-6 bg-emerald-900/80 border border-emerald-500/30 text-emerald-400 p-4 rounded-lg shadow-lg z-50 flex items-center space-x-3 backdrop-blur-sm" data-id="element-1640">
          <CheckCircle className="h-5 w-5" data-id="element-1641" />
          <span data-id="element-1642">Profil bilgileriniz başarıyla güncellendi.</span>
        </div>}
      {/* Profil Bilgileri Kartı */}
      <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-1643">
        <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-1644">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6" data-id="element-1645">
            <div className="relative" data-id="element-1646">
              <img src={profileImage} alt="Öğretmen Profil Fotoğrafı" className="w-24 h-24 rounded-full object-cover" data-id="element-1647" />
              <button onClick={handleProfileImageClick} className="absolute -bottom-1 -right-1 p-1.5 rounded-full bg-emerald-600 text-white hover:bg-emerald-700 transition-colors" data-id="element-1648">
                <Camera className="w-4 h-4" data-id="element-1649" />
              </button>
              <input type="file" ref={fileInputRef} className="hidden" accept="image/*" onChange={handleFileChange} data-id="element-1650" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1651">
              {isEditing ? <div className="space-y-4" data-id="element-1652">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1653">
                    <div className="space-y-2" data-id="element-1654">
                      <label className="text-sm text-gray-400" data-id="element-1655">Ad Soyad</label>
                      <input type="text" value={formData.name} onChange={e => setFormData({
                    ...formData,
                    name: e.target.value
                  })} className="w-full bg-white/5 text-white rounded-lg px-4 py-2 border border-transparent focus:border-emerald-500 focus:ring-emerald-500/50" data-id="element-1656" />
                    </div>
                    <div className="space-y-2" data-id="element-1657">
                      <label className="text-sm text-gray-400" data-id="element-1658">E-posta</label>
                      <input type="email" value={userData.email} disabled className="w-full bg-black/20 text-gray-400 rounded-lg px-4 py-2 cursor-not-allowed" data-id="element-1659" />
                    </div>
                    <div className="space-y-2" data-id="element-1660">
                      <label className="text-sm text-gray-400" data-id="element-1661">Okul</label>
                      <input type="text" value={formData.school} onChange={e => setFormData({
                    ...formData,
                    school: e.target.value
                  })} className="w-full bg-white/5 text-white rounded-lg px-4 py-2 border border-transparent focus:border-emerald-500 focus:ring-emerald-500/50" data-id="element-1662" />
                    </div>
                    <div className="space-y-2" data-id="element-1663">
                      <label className="text-sm text-gray-400" data-id="element-1664">Branş</label>
                      <input type="text" value={userData.branch} disabled className="w-full bg-black/20 text-gray-400 rounded-lg px-4 py-2 cursor-not-allowed" data-id="element-1665" />
                    </div>
                  </div>
                  <div className="flex justify-end gap-3" data-id="element-1666">
                    <button onClick={() => setIsEditing(false)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors" data-id="element-1667">
                      <X className="w-4 h-4" data-id="element-1668" /> İptal
                    </button>
                    <button onClick={handleSave} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 transition-colors" data-id="element-1669">
                      <Save className="w-4 h-4" data-id="element-1670" /> Kaydet
                    </button>
                  </div>
                </div> : <div className="space-y-4" data-id="element-1671">
                  <div className="flex items-center justify-between" data-id="element-1672">
                    <h2 className="text-2xl font-bold" data-id="element-1673">{userData.name}</h2>
                    <button onClick={() => {
                  setFormData({
                    name: userData.name,
                    school: userData.school
                  });
                  setIsEditing(true);
                }} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors" data-id="element-1674">
                      <Edit className="w-4 h-4" data-id="element-1675" /> Düzenle
                    </button>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2" data-id="element-1676">
                    <div className="flex items-center gap-2 text-gray-400" data-id="element-1677">
                      <Mail className="w-4 h-4" data-id="element-1678" /> <span data-id="element-1679">{userData.email}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-400" data-id="element-1680">
                      <School className="w-4 h-4" data-id="element-1681" />{' '}
                      <span data-id="element-1682">{userData.school}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-400" data-id="element-1683">
                      <Book className="w-4 h-4" data-id="element-1684" />{' '}
                      <span data-id="element-1685">{userData.branch}</span>
                    </div>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {/* Hesap Ayarları */}
      <div data-id="element-1686">
        <h2 className="text-xl font-bold mb-4" data-id="element-1687">Hesap Ayarları</h2>
        <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-teal-600" data-id="element-1688">
          <div className="relative p-6 bg-black/90 rounded-lg" data-id="element-1689">
            <div className="space-y-4" data-id="element-1690">
              <button onClick={() => setShowPasswordModal(true)} className="w-full flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-lg transition-colors border border-gray-700/50 hover:border-emerald-500/30" data-id="element-1691">
                <div className="flex items-center gap-4" data-id="element-1692">
                  <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center" data-id="element-1693">
                    <Key className="w-5 h-5 text-emerald-400" data-id="element-1694" />
                  </div>
                  <div className="text-left" data-id="element-1695">
                    <span className="font-medium" data-id="element-1696">Şifre Değiştir</span>
                    <p className="text-sm text-gray-400 mt-0.5" data-id="element-1697">
                      Hesabınızın güvenliği için şifrenizi güncelleyin.
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500" data-id="element-1698" />
              </button>
              <button onClick={() => setShowEmailModal(true)} className="w-full flex items-center justify-between p-4 bg-white/5 hover:bg-white/10 rounded-lg transition-colors border border-gray-700/50 hover:border-emerald-500/30" data-id="element-1699">
                <div className="flex items-center gap-4" data-id="element-1700">
                  <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center" data-id="element-1701">
                    <Mail className="w-5 h-5 text-emerald-400" data-id="element-1702" />
                  </div>
                  <div className="text-left" data-id="element-1703">
                    <span className="font-medium" data-id="element-1704">E-posta Güncelle</span>
                    <p className="text-sm text-gray-400 mt-0.5" data-id="element-1705">
                      İletişim e-posta adresinizi değiştirin.
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500" data-id="element-1706" />
              </button>
            </div>
            <div className="mt-8 pt-6 border-t border-gray-800" data-id="element-1707">
              <button onClick={() => setShowLogoutModal(true)} className="flex items-center gap-3 px-4 py-3 rounded-lg bg-white/5 hover:bg-red-500/10 transition-colors text-red-400 hover:text-red-300 border border-red-500/20 hover:border-red-500/40" data-id="element-1708">
                <LogOut className="w-5 h-5" data-id="element-1709" />
                <span className="font-medium" data-id="element-1710">Çıkış Yap</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Modals */}
      <PasswordChangeModal isOpen={showPasswordModal} onClose={() => setShowPasswordModal(false)} data-id="element-1711" />
      <EmailUpdateModal isOpen={showEmailModal} onClose={() => setShowEmailModal(false)} data-id="element-1712" />
      <LogoutConfirmModal isOpen={showLogoutModal} onClose={() => setShowLogoutModal(false)} data-id="element-1713" />
    </div>;
}